"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const i18n_1 = __importDefault(require("../i18n"));
class Logo extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.handleFileSelect = (evt) => {
            const target = evt.target;
            const files = target.files;
            if (!files || !files.length) {
                return;
            }
            let f = files[0];
            if (f) {
                const r = new window.FileReader();
                r.onload = () => {
                    // @ts-ignore
                    const contents = target.result;
                    try {
                        const json = JSON.parse(contents);
                        if (json.native && json.common) {
                            if (json.common.name !== this.props.common.name) {
                                this.props.onError && this.props.onError(i18n_1.default.t('ra_otherConfig', json.common.name));
                            }
                            else {
                                this.props.onLoad && this.props.onLoad(json.native);
                            }
                        }
                        else {
                            this.props.onError && this.props.onError(i18n_1.default.t('ra_invalidConfig'));
                        }
                    }
                    catch (err) {
                        this.props.onError && this.props.onError(err === null || err === void 0 ? void 0 : err.toString());
                    }
                };
                r.readAsText(f);
            }
            else {
                alert('Failed to open JSON File');
            }
        };
    }
    static generateFile(fileName, obj) {
        const el = window.document.createElement('a');
        el.setAttribute('href', `data:application/json;charset=utf-8,${encodeURIComponent(JSON.stringify(obj, null, 2))}`);
        el.setAttribute('download', fileName);
        el.style.display = 'none';
        window.document.body.appendChild(el);
        el.click();
        window.document.body.removeChild(el);
    }
    download() {
        const result = {
            _id: `system.adapter.${this.props.common.name}.${this.props.instance}`,
            common: JSON.parse(JSON.stringify(this.props.common)),
            native: this.props.native,
        };
        // remove unimportant information
        if (result.common.news) {
            delete result.common.news;
        }
        if (result.common.titleLang) {
            delete result.common.titleLang;
        }
        if (result.common.desc) {
            delete result.common.desc;
        }
        // window.open('data:application/iobroker; content-disposition=attachment; filename=' + result._id + '.json,' + JSON.stringify(result, null, 2));
        Logo.generateFile(`${result._id}.json`, result);
    }
    upload() {
        const input = window.document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('id', 'files');
        input.setAttribute('opacity', '0');
        input.addEventListener('change', this.handleFileSelect, false);
        (input.click)();
    }
    render() {
        return react_1.default.createElement("div", { className: this.props.className, style: this.props.style },
            this.props.common.icon ?
                react_1.default.createElement("img", { src: this.props.common.icon, style: {
                        padding: 8,
                        width: 64,
                    }, alt: "logo" }) : null,
            this.props.common.readme ?
                react_1.default.createElement(material_1.Fab, { size: "small", color: "primary", "aria-label": "Help", style: {
                        marginRight: 5,
                        marginTop: 5,
                        float: 'right',
                    }, onClick: () => {
                        const win = window.open(this.props.common.readme, '_blank');
                        win === null || win === void 0 ? void 0 : win.focus();
                    } },
                    react_1.default.createElement(icons_material_1.Help, null)) : null,
            react_1.default.createElement(material_1.Fab, { size: "small", color: "primary", "aria-label": "Load config", style: {
                    marginRight: 5,
                    marginTop: 5,
                    float: 'right',
                }, title: i18n_1.default.t('ra_Load configuration from file'), onClick: () => this.upload() },
                react_1.default.createElement(icons_material_1.VerticalAlignTop, null)),
            react_1.default.createElement(material_1.Fab, { size: "small", color: "primary", "aria-label": "Save config", style: {
                    marginRight: 5,
                    marginTop: 5,
                    float: 'right',
                }, title: i18n_1.default.t('ra_Save configuration to file'), onClick: () => this.download() },
                react_1.default.createElement(icons_material_1.VerticalAlignBottom, null)));
    }
}
exports.default = Logo;
